import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AccessRightKeys, INITIAL_ACCESS_RIGHTS_STATE } from 'store/access-rights/constants.ts'
import { AccessRights } from 'store/access-rights/types.ts'

export const accessRightsSlice = createSlice({
  name: 'accessRights',
  initialState: INITIAL_ACCESS_RIGHTS_STATE,
  reducers: {
    setSpecificAccessRights: {
      reducer: (state, action: PayloadAction<{ key: AccessRightKeys; value: any }>) => {
        const { key, value } = action.payload
        state[key] = value
      },
      prepare: <K extends AccessRightKeys>(key: K, value: AccessRights[K]) => {
        return { payload: { key, value } }
      }
    },
    setAllAccessRights: (_state, { payload }: PayloadAction<AccessRights>) => {
      return payload
    },
    resetAccessRights: () => INITIAL_ACCESS_RIGHTS_STATE
  },
  selectors: {
    selectSpecificAccessRight: <K extends AccessRightKeys>(accessRights: AccessRights, key: K): AccessRights[K] => accessRights[key]
  }
})

export const { setSpecificAccessRights, setAllAccessRights, resetAccessRights } = accessRightsSlice.actions
export const { selectSpecificAccessRight } = accessRightsSlice.selectors

export default accessRightsSlice.reducer
